import { useContext } from 'react'

import { LoaderContext } from '../providers/loader-provider'

const useLoaderTransition = () => {
  const state = useContext(LoaderContext)

  const startLoaderTransition = (
    func: () => void,
    loaderProps?: { title?: string; description?: string },
  ) => {
    if (state?.setLoaderProps) {
      !!loaderProps?.title && !!loaderProps?.description && state.setLoaderProps({ ...loaderProps })
    }

    state?.startTransition && state.startTransition(func)
  }

  return {
    startLoaderTransition,
    pending: state?.pending,
  }
}

export default useLoaderTransition
